import * as actions from './saleCategory/actions'
import * as mutations from './saleCategory/mutations'
import * as getters from './saleCategory/getters'

import { dataProps } from './saleCategory/properties'

const state = {
    list: [],
    nav: {
        page_number: 0,
        limit: 50,
        total: 0
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/saleCategory.js